import {Component, effect} from '@angular/core';
import {PerfilServicesService} from '../services/perfil.service';
import {LayoutService} from 'src/app/layout/service/app.layout.service';
import * as CryptoJS from 'crypto-js'
import {TramitePagosService} from "../../pagos/services/tramite-pagos.service";
import {LoginServices} from "../../../auth/login/services/login.service";
import {FileUtilsService} from "../../../shared/services/file-utils-service";

@Component({
    selector: 'app-perfil-page',
    templateUrl: './perfil-page.component.html',
    styleUrls: ['./perfil-page.component.css']
})
export class PerfilPageComponent {
    numeroDocumento: string = ""
    imagenDemo: string = ''
    showEditarFoto: boolean = false
    constructor(private perfil: PerfilServicesService, public loginServices: LoginServices,
                private perfilUser: PerfilServicesService, private layoutService: LayoutService,
                public tramitePagosService: TramitePagosService,protected fileUtilsService: FileUtilsService) {
    }
    ngOnInit(): void {
        this.tramitePagosService.consultarSaldo()
    }
    fotoPerfil: any = null
    guardarImagen(e: any) {
        this.fotoPerfil = e.currentFiles ? e.currentFiles[0] : e.currentFiles[0]
    }
    convertirImagen(e: any) {
        var pattern = /image-*/;
        var reader = new FileReader();
        if (!this.fotoPerfil.type.match(pattern)) {
            alert('invalid format');
            return;
        }
        reader.onload = this._handleReaderLoaded.bind(this.fotoPerfil);
        reader.readAsDataURL(this.fotoPerfil);
    }
    _handleReaderLoaded(e: any) {
        let reader = e.target;
        this.perfilUser.imageDemo.set(reader.result)
        const byteCharacters = atob(reader.result.split(',')[1]);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const hash = CryptoJS.SHA256(byteArray.toString());
    }
    actualizarFoto(e: any) {
        var file = e.files ? e.files[0] : e.files[0]
        var pattern = /image-*/;
        var reader = new FileReader();
        if (!file.type.match(pattern)) {
            alert('invalid format');
            return;
        }
        reader.onload = this._handleReaderLoaded.bind(this);
        reader.readAsDataURL(file);
        let hash = this.calcularHash(reader.result as string);
    }
    calcularHash(dataURL: string) {
        const byteCharacters = atob(dataURL.split(',')[1]);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
    }
    imagenPerfilEffect = effect(() => {
        this.imagenDemo = this.perfilUser.imageDemo()
    })
}
